export default __webpack_public_path__ + "static/media/RollCallVertLogoSmall.2c22ec0e.png";